import { graphql, compose } from 'react-apollo'
import { getVerifiedToken } from '../../common/h5Session'
import Knowledge from './components/index'
import {
  getBlogs,
  getCorrelationBlogs,
  getBlogRecommend,
  getArticleHelpState,
  queryFollowState,
} from './actions/queries'
import {
  updateCommentorVotes,
  updateVideoAnalysis,
  updateBlogVote,
  insertBlogComment,
  insertView,
  updateArticleHelpState,
  cancelBlogComment,
  getAppVision,
  updateVideoItem,
  patientQueryById,
  mutationSaveFollow,
} from './actions/mutation'
import get from 'lodash/get'

import { getPatientIdFromUrl } from '../../utils'

export default compose(
  graphql(getBlogs, {
    name: 'blogs',
    options: (props) => ({
      variables: {
        blogId: get(props, 'match.params.knowledgeId'),
        systemType: get(props, 'match.params.systemType', 'BG'),
        patientId: getPatientIdFromUrl(props)
      },
      fetchPolicy: 'network-only',
    }),
  }),
  graphql(queryFollowState, {
    // 按患者维度、只服务互动的查询：未登录不查，避免一打开文章就弹登录框
    skip: () => !getVerifiedToken(),
    name: 'getFollowState',
    options: (props) => ({
      variables: {
        selfId: getPatientIdFromUrl(props),
        blogId: get(props, 'match.params.knowledgeId'),
      },
      fetchPolicy: 'network-only',
    }),
  }),
  graphql(mutationSaveFollow, { name: 'saveFollow' }),
  graphql(updateCommentorVotes, { name: 'updateCommentorVotes' }),
  graphql(updateVideoItem, { name: 'updateVideoAnalysis' }),
  graphql(updateBlogVote, { name: 'updateBlogVote' }),
  graphql(insertBlogComment, { name: 'insertBlogComment' }),
  graphql(insertView, { name: 'insertView' }),
  graphql(getAppVision, {
    name: 'appVision',
    options: (props) => {
      const patientId = getPatientIdFromUrl(props)
      return {
        variables: {
          patientId,
        },
        fetchPolicy: 'network-only',
      }
    },
  }),
  //  graphql(updateView, {name: 'updateView'}),
  graphql(updateArticleHelpState, { name: 'updateArticleHelpState' }),
  graphql(getArticleHelpState, {
    // 按患者维度、只服务互动的查询：未登录不查，避免一打开文章就弹登录框
    skip: () => !getVerifiedToken(),
    name: 'articleHelpState',
    options: (props) => ({
      variables: {
        articleId: get(props, 'match.params.knowledgeId'),
        patientId: getPatientIdFromUrl(props),
      },
      fetchPolicy: 'network-only',
    }),
  }),
  graphql(cancelBlogComment, { name: 'cancelBlogComment' }),
  // graphql(getCorrelationBlogs, {
  //   name: 'correlationBlogs',
  //   options: (props) => ({
  //     variables: {
  //       blogId: get(props, 'match.params.knowledgeId'),
  //     },
  //     fetchPolicy: 'network-only',
  //   }),
  // }),
  graphql(getBlogRecommend, {
    name: 'correlationBlogs',
    options: (props) => ({
      variables: {
        blogId: get(props, 'match.params.knowledgeId'),
        patientId: getPatientIdFromUrl(props),
      },
      fetchPolicy: 'network-only',
    }),
  }),
  graphql(patientQueryById, {
    name: 'patientQueryById',
    // 患者资料只服务于互动（评论框的「同步至说一说」默认值、关注按钮是否显示），
    // 阅读不需要。未登录时不查，避免一打开文章就弹登录框；
    // 登录后根组件重渲染，skip 重新求值，这里会自动补查
    skip: () => !getVerifiedToken(),
    options: (props) => ({
      variables: {
        patientId: getPatientIdFromUrl(props),
      },
      fetchPolicy: 'network-only',
    }),
  })
)(Knowledge)



// WEBPACK FOOTER //
// ./src/modules/knowledge/index.js